
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/carriers/[carrier]",
      function () {
        return require("private-next-pages/carriers/[carrier].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/carriers/[carrier]"])
      });
    }
  